// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application';
import { Application } from '@hotwired/stimulus';
import TabsController from './tabs_controller';

import ChatController from './chat_controller';
application.register('chat', ChatController);

import CodemirrorController from './codemirror_controller';
application.register('codemirror', CodemirrorController);

import CustomDomainController from './custom_domain_controller';
application.register('custom-domain', CustomDomainController);

import AssistantChatController from './assistant_chat_controller';
application.register('assistant-chat', AssistantChatController);

import NavigationController from './navigation_controller';
application.register('navigation', NavigationController);

import OpacitySliderController from './opacity_slider_controller';
application.register('opacity-slider', OpacitySliderController);

import RealTimeColorInputController from './real_time_color_input_controller';
application.register('real-time-color-input', RealTimeColorInputController);

import ServicesController from './services_controller';
application.register('services', ServicesController);

import RegistrationSettingsFormController from './registration_settings_form_controller';
application.register(
  'registration-settings-form',
  RegistrationSettingsFormController
);

import ReplaceContentToggleController from './replace_content_toggle_controller';
application.register('replace-content-toggle', ReplaceContentToggleController);

import UploadController from './upload_controller';
application.register('upload', UploadController);

import CharacterCounterController from './character-counter';
application.register('character-counter', CharacterCounterController);

import StudentServicesController from './student_services_controller';
application.register('student-services', StudentServicesController);

import EventKioskController from './event_kiosk_controller';
application.register('event-kiosk', EventKioskController);

import MobileCheckInController from './mobile_check_in_controller';
application.register('mobile-check-in', MobileCheckInController);

import MciFiltersController from './mci_filters_controller';
application.register('mci-filters', MciFiltersController);

import MciUserProfileController from './mci_user_profile_controller';
application.register('mci-user-profile', MciUserProfileController);

import MobileSalesController from './mobile_sales_controller';
application.register('mobile-sales', MobileSalesController);

import EventKioskToggleController from './event_kiosk_toggle_controller';
application.register('event-kiosk-toggle', EventKioskToggleController);

import SalesTeamController from './sales_team_controller';
application.register('sales-team', SalesTeamController);

import SalesTeamNavBadgeController from './sales_team_nav_badge_controller';
application.register('sales-team-nav-badge', SalesTeamNavBadgeController);

import AnalyticsChatController from './analytics_chat_controller';
application.register('analytics-chat', AnalyticsChatController);

import AnalyticsTeamController from './analytics_team_controller';
application.register('analytics-team', AnalyticsTeamController);

import MarketingTeamController from './marketing_team_controller';
application.register('marketing-team', MarketingTeamController);

import BrandDigestController from './brand_digest_controller';
application.register('brand-digest', BrandDigestController);

import AppDesignChatController from './app_design_chat_controller';
application.register('app-design-chat', AppDesignChatController);

import ReceiptController from './receipt_controller';
application.register('receipt', ReceiptController);

import StripOverflowController from './strip_overflow_controller';
application.register('strip-overflow', StripOverflowController);

application.register('tabs', TabsController);

import LibraryUploadController from './library_upload_controller';
application.register('library-upload', LibraryUploadController);

import LibraryTabsController from './library_tabs_controller';
application.register('library-tabs', LibraryTabsController);

import BrandUploadController from './brand_upload_controller';
application.register('brand-upload', BrandUploadController);

import RecorderController from './recorder_controller';
application.register('recorder', RecorderController);

import UserImportUploadController from './user_import_upload_controller';
application.register('user-import-upload', UserImportUploadController);

import StripeCardProgressController from './stripe_card_progress_controller';
application.register('stripe-card-progress', StripeCardProgressController);
